export function getBuyNowQueryParamsCookieDomain(): string | undefined {
  const { hostname } = window.location;

  if (hostname === 'constantcontact.com' || hostname.endsWith('.constantcontact.com')) {
    return '.constantcontact.com';
  }

  return undefined;
}
